import React from "react";
import MetaTags from "react-meta-tags";
import Subscribe from "../../component/Subscribe";
import "../../common/SCSS/newsletterStyle.css";

function Newsletter_37() {
  return (
    <>
      <section
        className="about-banner-section"
        style={{ padding: "150px 0 62px" }}
      >
        <div className="about-circle">
          <div className="about-circle-1"></div>
          <div className="about-circle-2"></div>
          <div className="about-circle-3"></div>
          <div className="about-circle-4"></div>
          <div className="about-circle-5"></div>
        </div>
        <div className="about-banner-container">
          <div className="about-content">
            <h1 className="about-title" style={{ paddingTop: "25px" }}>
              SustainabilityConnect
            </h1>
            <p
              className="about-description"
              style={{ fontSize: "25px", marginTop: "18px", marginBottom: "0" }}
            >
              Newsletter October 2025
            </p>
          </div>
        </div>
        <div className="about-elements">
          <div className="about-element-1"></div>
          <div className="about-element-2"></div>
          <div className="about-element-3"></div>
          <div className="about-element-4"></div>
          <div className="about-element-5"></div>
        </div>
      </section>
      <div className="newsletter-container">
        <MetaTags>
          <title>
            California Announces Climate Disclosure Requirements for 4,000+
            Companies Under Senate Bills 253 and 261.
          </title>
          <meta
            name="description"
            content="California has published a preliminary list of over 4,000 companies that fall under the scope of its new climate disclosure regulations, introduced through Senate Bills 253 and 261."
          />
          <meta
            property="og:title"
            content="UpdaptCSR | Sustainability Platform"
          />
        </MetaTags>

        <div
          className="Newsletter-title1"
          style={{ paddingTop: "56px", fontSize: "32px" }}
        >
          California Announces Climate Disclosure Requirements for 4,000+
          Companies Under Senate Bills 253 and 261.
        </div>
        <figure style={{ marginTop: "25px" }}>
          <img
            className="picture"
            src={require("../../../../../assets/Newsletter/Oct_2025_1.webp")}
            alt="California Announces Climate Disclosure Requirements for 4,000+ Companies Under Senate Bills 253 and 261."
            loading="lazy"
          />
        </figure>
        <p>
          California has published a preliminary list of over 4,000 companies
          that fall under the scope of its new climate disclosure regulations,
          introduced through Senate Bills 253 and 261. Unlike earlier voluntary
          or sector-specific reporting practices, these rules create a uniform,
          state-level framework for climate-related disclosures. Applicable to
          both public and private companies that do business in California and
          meet the revenue thresholds, the regulations mark a significant shift
          from prior expectations, which often relied on self-reporting or
          investor-driven standards.
        </p>
        <p>
          Previously, climate disclosures in the United States were largely
          guided by voluntary frameworks or fragmented state and industry
          initiatives. Under the new laws, Senate Bill 253 requires companies
          with more than USD 1 billion in annual revenue to disclose their Scope
          1 and Scope 2 greenhouse gas emissions beginning in 2026, and Scope 3
          emissions starting in 2027. Senate Bill 261 introduces biennial
          reporting obligations for companies with over USD 500 million in
          revenue, focusing on climate-related financial risks and the measures
          taken to address them.
        </p>
        <p>
          The companies identified are those with substantial economic activity
          in California, even if they are headquartered elsewhere. This reflects
          the state’s intention to capture the broader environmental footprint
          of major businesses operating within its borders. The move shifts
          climate disclosure from a selective practice to a regulatory
          expectation for a wide cross-section of the corporate landscape,
          reinforcing California’s role in shaping climate policy standards.
        </p>

        <div className="updapt-views">
          <div className="views" style={{ display: "flex" }}>
            <img
              src={require("../../../../../assets/Newsletter/view1.svg")}
              width="40px"
              height="40px"
              alt="view1"
            />
            <h3>Updapt Views:</h3>
          </div>
          <p style={{ marginLeft: " 22px", color: "white", width: "96%" }}>
            These disclosure requirements signal a shift in expectations for
            corporate accountability, placing emphasis on verifiable data and
            structured reporting processes. Companies will need to ensure access
            to accurate emissions data across operations and supply chains,
            supported by governance systems that can meet regulatory scrutiny.
            As timelines approach, reporting consistency, comparability, and
            assurance will become central to how climate risks and emissions are
            communicated to regulators, investors, and the public.
          </p>
        </div>
        <div className="Newsletter-title" style={{ paddingTop: " 57px" }}>
          China Outlines 2035 Strategy with First-Ever Absolute Emissions
          Reduction Goal.
        </div>
        <div className="Newsletter-picture">
          <figure style={{ marginTop: "25px" }}>
            <img
              className="picture"
              src={require("../../../../../assets/Newsletter/Oct_2025_2.webp")}
              alt="China Outlines 2035 Strategy with First-Ever Absolute Emissions Reduction Goal."
              loading="lazy"
            />
          </figure>
        </div>
        <p>
          China has outlined its first absolute greenhouse gas reduction target,
          aiming to lower emissions by 7–10 percent from peak levels by 2035.
          This move includes expanding the country’s installed wind and solar
          power capacity to 3,600 gigawatts and increasing the share of
          non-fossil fuels in primary energy consumption to over 30 percent. The
          initiative also broadens the scope of climate commitments by including
          all major greenhouse gases, such as carbon dioxide, methane, nitrous
          oxide, and fluorinated gases.
        </p>
        <p>
          Over the past decade, China has steadily advanced its climate agenda.
          Forest coverage has increased significantly, now reaching
          approximately 25 percent of national land area. The “green barrier”
          forestation project spanning thousands of kilometers has been
          completed, strengthening land-based carbon sinks. In energy terms, the
          non-fossil fuel share of primary consumption rose to 17.9 percent by
          2023. Total greenhouse gas emissions in 2021 stood at approximately
          14.3 billion tonnes of CO₂ equivalent, offset in part by 1.3 billion
          tonnes through land use and forestry sinks.
        </p>
        <p>
          To support these goals, China is enhancing its national emissions
          trading system. Legal regulations enacted in 2024 now provide clearer
          guidance on trading, registration, and verification processes. The
          market is expected to expand beyond the power sector to industries
          such as cement, steel, and aluminum. Additionally, new methodologies
          for voluntary carbon markets are being introduced, including offshore
          wind, solar thermal, and ecosystem restoration.
        </p>

        <div className="updapt-views">
          <div className="views" style={{ display: "flex" }}>
            <img
              src={require("../../../../../assets/Newsletter/view1.svg")}
              width="40px"
              height="40px"
              alt="view1"
            />
            <h3>Updapt Views:</h3>
          </div>
          <p style={{ marginLeft: " 22px", color: "white", width: "96%" }}>
            To align with China’s 2035 absolute emissions target, companies must
            embed carbon intelligence into strategic planning. This includes
            scenario modeling, low-carbon investment pivots, lifecycle emission
            accounting, and early integration with the expanding national ETS.
            Proactive positioning in carbon markets and supply chain
            decarbonization will define long-term competitiveness and regulatory
            resilience.
          </p>
        </div>
        <div className="Newsletter-title" style={{ paddingTop: " 57px" }}>
          Australia Commits to 62 to 70% Emissions Cut by 2035.
        </div>
        <figure style={{ marginTop: "25px" }}>
          <img
            className="picture"
            src={require("../../../../../assets/Newsletter/Oct_2025_3.webp")}
            alt="Australia Commits to 62 to 70% Emissions Cut by 2035."
            loading="lazy"
          />
        </figure>
        <p>
          Australia has announced a national target to reduce greenhouse gas
          emissions by 62 to 70 percent below 2005 levels by 2035. This
          commitment, submitted under the Paris Agreement, marks a significant
          increase in ambition and will be implemented through a multi-year
          emissions budget covering the period from 2031 to 2035. The target is
          backed by the country’s Net Zero Plan and six sector-specific
          strategies, ensuring a whole-of-economy approach to cut emissions and
          accelerate the energy transition.
        </p>
        <p>
          The government’s roadmap focuses on clean electricity,
          electrification, clean fuels, carbon removals, and advanced
          technologies. Programs such as the Capacity Investment Scheme,
          Safeguard Mechanism, and Cheaper Home Batteries initiative are already
          helping reshape the energy landscape. Australia aims to achieve 82
          percent renewable electricity by 2030, positioning itself as a leader
          in green manufacturing and exports of clean hydrogen, green metals,
          and critical minerals needed globally for net zero transitions.
        </p>
        <p>
          Australia is responding to increasing climate-related risks, including
          severe floods and rising insurance costs. The economic case for action
          is strong, with clean energy investment projected to add more than 300
          billion dollars annually to the national economy by mid-century. As a
          key player in the Indo-Pacific region, Australia is also scaling its
          climate diplomacy and is bidding to co-host COP31 alongside Pacific
          nations.
        </p>

        <div className="updapt-views">
          <div className="views" style={{ display: "flex" }}>
            <img
              src={require("../../../../../assets/Newsletter/view1.svg")}
              width="40px"
              height="40px"
              alt="view1"
            />
            <h3>Updapt Views:</h3>
          </div>
          <p style={{ marginLeft: " 22px", color: "white", width: "96%" }}>
            Australia’s 2035 climate target will reshape industrial dynamics by
            accelerating capital flight from legacy emissions-intensive
            operations into scalable low-carbon systems. Sectors like energy,
            transport, and manufacturing will undergo structural rewiring,
            driven by regulatory certainty and investment incentives. This pivot
            will redefine value chains, compress carbon risk premiums, and
            catalyse a recalibration of industrial competitiveness in a
            decarbonising global market.
          </p>
        </div>
        <div className="Newsletter-title" style={{ paddingTop: " 57px" }}>
          Denmark Launches Landmark Sovereign Green Bond Under EU Green Bond
          Standard.
        </div>
        <figure style={{ marginTop: "25px" }}>
          <img
            className="picture"
            src={require("../../../../../assets/Newsletter/Oct_2025_4.webp")}
            alt="Denmark Launches Landmark Sovereign Green Bond Under EU Green Bond Standard."
            loading="lazy"
          />
        </figure>
        <p>
          The Kingdom of Denmark has issued its first sovereign green bond under
          the EU Green Bond Standard, marking a significant advancement in its
          national climate finance strategy. The issuance directly supports
          Denmark’s legally binding climate targets, including a 70 percent
          reduction in greenhouse gas emissions by 2030 from 1990 levels and
          full climate neutrality by 2050. The framework follows the EU Taxonomy
          for sustainable activities and aligns with the ICMA Green Bond
          Principles, ensuring that all financed activities are environmentally
          sound and transparently reported.
        </p>
        <p>
          Proceeds from the bond will be directed toward public investments in
          renewable energy, clean transportation infrastructure, and sustainable
          land use. Major projects include the electrification of approximately
          1,350 kilometers of railway by 2030, contributing to a nationwide
          shift toward zero-emission transport. In the energy sector, the
          expansion of the electricity grid by 2,700 kilometers by 2030 will
          enhance the integration of renewable sources such as wind and solar.
          Additionally, land use initiatives include afforestation of 250,000
          hectares by 2045 and the rewetting of 140,000 hectares of carbon-rich
          lowlands, supporting both carbon sequestration and biodiversity.
        </p>
        <p>
          This issuance builds on Denmark’s strong performance in emissions
          reduction. As of 2023, the country had already achieved a 51 percent
          cut in greenhouse gas emissions from 1990 levels. According to
          projections by the Danish Ministry of Climate, Energy and Utilities,
          emissions are expected to fall by 72 percent by 2030. The bond also
          incorporates a twin bond structure, allowing investors to switch
          between the green bond and its conventional counterpart, enhancing
          market liquidity and pricing transparency.
        </p>

        <div className="updapt-views">
          <div className="views" style={{ display: "flex" }}>
            <img
              src={require("../../../../../assets/Newsletter/view1.svg")}
              width="40px"
              height="40px"
              alt="view1"
            />
            <h3>Updapt Views:</h3>
          </div>
          <p style={{ marginLeft: " 22px", color: "white", width: "96%" }}>
            The issuance of Denmark’s sovereign green bond will channel capital
            into low-carbon infrastructure, subtly reshaping the economy toward
            long-term resilience and resource efficiency. By embedding
            sustainability within fiscal policy, it signals a shift from
            carbon-intensive growth to regenerative investment logic. This
            alignment between public finance and ecological thresholds not only
            anchors investor confidence but also fosters systemic innovation,
            positioning green spending as a macroeconomic stabilizer in an era
            of climate-linked volatility.
          </p>
        </div>
        <div className="Newsletter-title" style={{ paddingTop: " 57px" }}>
          EU Launches €17.5 Billion Initiative to Boost Energy Efficiency Across
          350,000+ SMEs.
        </div>
        <figure style={{ marginTop: "25px" }}>
          <img
            className="picture"
            src={require("../../../../../assets/Newsletter/Oct_2025_5.webp")}
            alt="EU Launches €17.5 Billion Initiative to Boost Energy Efficiency Across 350,000+ SMEs."
            loading="lazy"
          />
        </figure>

        <p>
          The European Union, in partnership with the European Investment Bank
          (EIB) Group, has launched a €17.5 billion financing initiative to
          support energy efficiency and decarbonisation among more than 350,000
          small and medium-sized enterprises (SMEs) across Europe. This
          large-scale programme builds on the EU’s Fit for 55 and REPowerEU
          strategies and is expected to mobilise over €65 billion in total
          investment by 2027. SMEs account for 99% of all EU businesses and
          consume around 13% of the EU's total energy; the initiative targets
          this segment as a critical lever in reaching the EU’s 2030 climate and
          energy targets.
        </p>
        <p>
          The funding will be channelled through a newly integrated platform
          combining the EIB Group’s lending instruments with advisory support
          under the InvestEU and LIFE Clean Energy Transition programmes. SMEs
          will gain access to tailored financial instruments via national
          promotional banks and commercial intermediaries. Additionally,
          private-sector partners will co-invest through dedicated platforms
          aimed at scaling investment into energy-efficient equipment,
          retrofits, and low-carbon technologies.
        </p>
        <p>
          A key component of the initiative is the introduction of
          performance-based financing models such as “energy efficiency as a
          service,” where businesses pay for verified energy savings rather than
          upfront capital investments. This approach reduces financial barriers
          and aligns with emerging trends in climate finance. Past EIB-supported
          programmes, such as ELENA (European Local Energy Assistance), have
          demonstrated strong success, leveraging €7 billion in sustainable
          investments over a decade. Building on these results, this initiative
          incorporates a dedicated working group under the Energy Efficiency
          Financial Institutions Group (EEFIG) to standardise practices and
          align project financing with the unique operational realities of SMEs
          across sectors.
        </p>

        <div className="updapt-views">
          <div className="views" style={{ display: "flex" }}>
            <img
              src={require("../../../../../assets/Newsletter/view1.svg")}
              width="40px"
              height="40px"
              alt="view1"
            />
            <h3>Updapt Views:</h3>
          </div>
          <p style={{ marginLeft: " 22px", color: "white", width: "96%" }}>
            This initiative is set to generate ripple effects across the
            European economy by embedding energy efficiency into the operational
            fabric of SMEs. Beyond carbon reduction, it fosters industrial
            resilience, cost competitiveness, and decentralized energy adoption.
            By shifting capital flows toward low-carbon assets, the programme
            reorients financial ecosystems around sustainability, creating a
            multiplier effect that strengthens regional supply chains,
            stimulates green innovation, and embeds climate-aligned value
            creation deep within Europe's economic structure.
          </p>
        </div>
      </div>
      <Subscribe />
    </>
  );
}

export default Newsletter_37;
